import client from "./client";

export type SearchKind = "employee" | "document" | "task";

export interface SearchHit {
  kind: SearchKind;
  id: string;
  title: string;
  subtitle: string;
  url: string;
  score?: number;
}

export interface SearchResponse {
  query: string;
  counts: Partial<Record<SearchKind, number>>;
  results: SearchHit[];
}

/**
 * Calls the unified /search endpoint.
 *
 * The backend is responsible for permission scoping (employees only see
 * themselves + their own tasks etc.), so the frontend can render whatever
 * the API returns without re-checking roles.
 */
export async function unifiedSearch(
  q: string,
  opts: { kinds?: SearchKind[]; limit?: number } = {},
): Promise<SearchResponse> {
  const params = new URLSearchParams({ q });
  if (opts.kinds?.length) params.set("kinds", opts.kinds.join(","));
  if (opts.limit) params.set("limit", String(opts.limit));
  const { data } = await client.get<SearchResponse>(
    `/search?${params.toString()}`,
  );
  return data;
}
